/**
 * Fluid type tokens for the community hub surfaces (filter drawer, shared
 * picker panels). `clamp(min, rem + vw, max)` scales the size smoothly with
 * the device width — slightly smaller on narrow phones, slightly larger on
 * wide screens — while the rem base still respects the user's font settings.
 */
export const FLUID_TYPE = {
  /** Sheet / section titles (~16px on a 360px phone → 18px on desktop). */
  title: 'clamp(1rem, 0.9rem + 0.5vw, 1.125rem)',
  /** Primary labels, option rows, inputs (~13px → 14px). */
  label: 'clamp(0.8125rem, 0.77rem + 0.2vw, 0.875rem)',
  /** Compact labels — e.g. the filter drawer's section items (~12.5px → 13.5px). */
  labelSm: 'clamp(0.78rem, 0.74rem + 0.2vw, 0.845rem)',
  /** Secondary values, helper and summary text (~11.5px → 12.5px). */
  caption: 'clamp(0.72rem, 0.68rem + 0.2vw, 0.78rem)',
  /** Uppercase group headings (~10.5px → 11.5px). */
  overline: 'clamp(0.655rem, 0.62rem + 0.15vw, 0.72rem)',
} as const;
